import React from 'react';
import { connect } from 'react-redux';
import useOnMount from '../../hooks/useOnMount';
import pageWrapper from '../../hoc/pageWrapper';
import { fetchApartment } from '../../actions/apartmentActions';
import ApplicationFormLoader from '../../components/applicationForm/applicationFormLoader';
import * as StyledApplication from './application.styles';
import PageError from '../../components/pageError';
import GrindavikApplicationForm from '../../components/applicationForm/grindavikApplicationForm';
 import useAuthentication from '../../hooks/useAuthentication/useAuthentication';
 import SafeRedirect from '../../helpers/safeRedirect/safeRedirect';

const GrindavikApplication = ({
	page,
	match,
	dispatch,
	apartmentReducer,
	 authReducer
}) => {
 	const {
		authenticated, 
		authInfo,
		 authDenied
	} = authReducer; 

	 if(authDenied) {
	 	return <SafeRedirect to={`/grindavik/ibud/${match.params.id}`} />;
	 }

	useAuthentication(authReducer.loading, authReducer.error, authenticated, dispatch);

	const {
		currentApartment, loading, error404, error500
	} = apartmentReducer;
	const error = error404 || error500;
	const apartmentId = match.params.id;
	const apartmentNotAvailable = (
		currentApartment === null
		|| currentApartment.Id !== apartmentId
	)
		&& !loading
		&& !error;

	useOnMount(() => {
		if(!loading && apartmentNotAvailable) {
			dispatch(fetchApartment(apartmentId, 'grindavik'));
		}
	});



	return (
		<StyledApplication.Wrapper>
			{
				(loading || apartmentNotAvailable) && <ApplicationFormLoader />
			}
			{
				!loading && !apartmentNotAvailable && (error404 || !apartmentId) && (
					<PageError
						title="404, íbúð fannst ekki"
						text="Ýmsar ástæður getur verið því að þessi slóð er ekki til. Efnið gæti hafa verið fært annað, ekki lengur í birtingu eða jafnvel fjarlægt af vefnum." />
				)
			}
			{
				!loading && !apartmentNotAvailable && error500 && (
					<PageError
						title="500, kerfisvilla"
						text="Eitthvað fór úrskeiðis þegar reynt var að sækja íbúðina, vinsamlegast reynið aftur seinna." />
				)
			}
			{
				!loading && !apartmentNotAvailable && !error && <GrindavikApplicationForm apartment={currentApartment} page={page} authInfo={authInfo} />
			}
		</StyledApplication.Wrapper>
	);
};

const mapStateToProps = (({ apartmentReducer, authReducer
 }) => ({
	apartmentReducer,
	authReducer
	}
));

export default connect(mapStateToProps, null)(pageWrapper(GrindavikApplication ));
